export interface Store {
  storeNumber: string;
  storeName: string;
  storeCity: string;
  storeState: string;
  parentStore: string;
}

export interface UserDetails {
  userId: string;
  currentStoreNumber?: string;
  userType: string;
  ibToken: string;
  ibTokenExpiration: string;
  userChainList?: Store[];
  userPermissionList: string[];
  apimSubscriptionKey: string;
}

export const MOCK_USER_DATA: UserDetails = {
  userId: 'qqiaa2',
  currentStoreNumber: '03600',
  userType: 'Retailer',
  ibToken: 'mock-ib-token-abc123',
  ibTokenExpiration: '',
  apimSubscriptionKey: '', // APIM subscription key is required when testing function app locally, but once deployed will be retrieved via RetrieveUserDetails API call
  userChainList: [
    {
      storeNumber: '03600',
      storeName: 'Westlake Ace Hardware',
      storeCity: 'Moberly',
      storeState: 'MO',
      parentStore: '03600',
    },
    {
      storeNumber: '00388',
      storeName: 'Westlake Ace Hardware',
      storeCity: 'Jefferson City',
      storeState: 'MO',
      parentStore: '00297',
    },
    {
      storeNumber: '03310',
      storeName: 'Westlake Ace Hardware',
      storeCity: 'Edmond',
      storeState: 'OK',
      parentStore: '00297',
    },
    {
      storeNumber: '17407',
      storeName: 'Ace Hardware of Pinole',
      storeCity: 'Pinole',
      storeState: 'CA',
      parentStore: '00297',
    },
    {
      storeNumber: '03265',
      storeName: 'Westlake Ace Hardware',
      storeCity: 'Lawrence',
      storeState: 'KS',
      parentStore: '00297',
    },
  ],
  userPermissionList: [
    'Adw_web_focus-read_only',
    'Marketing_Planning_Tool_Application_Access',
    'GrowthPlan-web_focus',
    'Confidentialcontent-read_only',
  ],
};
